import * as service from './services'
import to from 'await-to-js'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getUfs ({dispatch, getters}) {
    const [error, response = { data: null }] = await to(service.getUfs())
    if (error) {
      throw error
    }
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/uf/index.js